import { Component } from 'react'
import AuthApis from '../hepler/authApis.service';
import { postMessage } from '../utils/common.utils';
import RedirectionCard from './Sections/RedirectionCard';
import { withTranslation } from '../hoc/withTranslation';
import VoiceJourneyRedirectionCard from './Sections/VoiceJourneyRedirectionCard';

class ConsentStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            time: global.redirectTimer || 5,
            isCloseWindow: false,
            sessionError: false
        };
        this.authApis = new AuthApis()
    }
    async componentDidMount() {
        if (global.isRedirect === 'true' && this.props?.location?.state?.type !== 'voice journey') {
            await this.redirect()
        } else {
            await this.logout()
        }
    }
    
    redirectIfConsentActioned = () => {
        if (global.redirectUrl) {
            this.setState({ isCloseWindow: false })
            postMessage('exit', 'EXPIRED_LINK');
            this.id = setInterval(() => {
                this.setState((prevState, prevProps) => ({
                    time: prevState.time - 1
                }));
                if (this.state.time === 0) {
                    clearInterval(this.id);
                    this.setState({ time: 0 });
                    if (global.isRedirect) {
                        if (global.redirectUrl?.includes('?')) {
                            window.location.replace(
                                global.redirectUrl + '&ecres=' + global.encryptedres + '&resdate=' + global.resDate + '&fi=' + global.encryptedFiId
                            )
                        } else {
                            window.location.replace(
                                global.redirectUrl + '?ecres=' + global.encryptedres + '&resdate=' + global.resDate + '&fi=' + global.encryptedFiId
                            )
                        }
                    }
                }
            }, 1000);
        } else {
            postMessage('exit', 'EXPIRED_LINK');
        }
    }

    redirectIfConsentActioned = () => {
        if (global.redirectUrl) { 
            this.setState({ isCloseWindow: false })
            postMessage('exit', 'EXPIRED_LINK');
            this.id = setInterval(() => {
                this.setState((prevState, prevProps) => ({
                    time: prevState.time - 1
                }));
                if (this.state.time === 0) {
                    clearInterval(this.id);
                    this.setState({ time: 0 });
                    if (global.isRedirect) {
                        if (global.redirectUrl?.includes('?')) {
                            window.location.replace(
                                global.redirectUrl + '&ecres=' + global.encryptedres + '&resdate=' + global.resDate + '&fi=' + global.encryptedFiId
                            )
                        } else {
                            window.location.replace(
                                global.redirectUrl + '?ecres=' + global.encryptedres + '&resdate=' + global.resDate + '&fi=' + global.encryptedFiId
                            )
                        }
                    }
                }
            }, 1000);
        } else {
            postMessage('exit', 'EXPIRED_LINK');
        }       
    }

    startTimer = (payload) => {
        this.id = setInterval(() => {
            this.setState((prevState, prevProps) => ({
                time: prevState.time - 1
            }));
            if (this.state.time === 0) {
                clearInterval(this.id);
                this.setState({ time: 0 });
                if (payload['redirectUrl'].includes('?')) {
                    window.location.replace(payload['redirectUrl'] + "&ecres=" + payload["encryptedResponse"] + "&resdate=" + payload['responseDate'] + "&fi=" + payload['encryptedFiId'])
                } else {
                    window.location.replace(payload['redirectUrl'] + "?ecres=" + payload["encryptedResponse"] + "&resdate=" + payload['responseDate'] + "&fi=" + payload['encryptedFiId'])
                }
                if (this.props?.location?.state?.statusCode === 200) {
                    postMessage('consent', 'ACCEPT')
                } else {
                    postMessage('consent', 'DENY')
                }
            }
        }, 1000);
    }

    delay = ms => new Promise(res => setTimeout(res, ms));

    logout = async () => {
        this.authApis.logout(global.userId).then(res => {
            console.log("res", res);
            if (res?.status === "SUCCESS") {
                if (this.props?.location?.state?.statusCode === 200) {
                    postMessage('consent', 'ACCEPT')
                } else {
                    postMessage('consent', 'DENY')
                }
                console.log(res.message)
            } else {
                console.log(res.message)
            }

        })
    }
    redirect = () => {
        let status = this.props?.location?.state?.statusCode
        let code = (status === 200) ? 0 : status === 201? 1: status;
        if(this.authApis.getSID()===''){
            this.setState({ isCloseWindow: true })
            if (status === 410) {
                this.redirectIfConsentActioned();
            }
            return;
        }
        this.authApis.encryptRequest(code).then(res => {
            console.log("res redirect request", res);
            let payload = res?.payload;
            this.authApis.logout(global.userId).then(async res => {
                console.log("res", res);
                if (res?.status === "SUCCESS") {
                    if (this.props?.location?.state?.statusCode === 200) {
                        postMessage('consent', 'ACCEPT')
                    } else if (this.props?.location?.state?.statusCode === 201) {
                        postMessage('consent', 'DENY')
                    }
                    if (payload['redirectUrl'] && (payload['redirectUrl'] !== "none")) {
                        this.startTimer(payload)
                    } else {
                        this.setState({ isCloseWindow: true })
                    }
                    console.log(res?.message)
                } else {
                    console.log(res?.message)
                    this.setState({ isCloseWindow: true })
                }
            })
        })
    }
    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            if (this.props.history.action === 'POP') {
                window.confirm(this.props.t('login.messages.confirmBack'))
            }
        }
    }
    render() {
        return (
            this.props?.location?.state?.type === 'voice journey' ? (
                <VoiceJourneyRedirectionCard
                    statusCode={this.props?.location?.state?.statusCode}
                    errorCode={this.props?.location?.state?.errorCode}
                    errorMessage={this.props?.location?.state?.errorMessage}
                    errorDetails={this.props?.location?.state?.errorDetails}
                    customDetails={this.props.customDetails}
                />
            ) : (
                <RedirectionCard
                    statusCode={this.props?.location?.state?.statusCode}
                    isCloseWindow={this.state.isCloseWindow}
                    sessionError={this.state.sessionError}
                    time={this.state.time}
                />
            )
        )
    }
}

export default withTranslation(ConsentStatus);